import { APICallV2Post } from 'reactApp/api/APICall';

/** Проверка файлов на вирусы */
export class VirusScanAPICall extends APICallV2Post {
    _method = 'folder/viruscan';
}
